import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import MetaTags from 'react-meta-tags';
import ServicesSection from '../../components/home/ServicesSection';
import { useAuth } from '../../store/auth';
import { servicesPageData } from '../../data';
import { servicesPageDataArabic } from '../../data/indexArabic';

const Services = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? servicesPageData : servicesPageDataArabic;
  const [isSeeMore, setIsSeeMore] = useState(false);

  useEffect(() => {
    const scrollNavigation = () => {
      const topnav = document.getElementById("topnav");
      if (topnav) {
        if (window.scrollY > 80) {
          topnav.classList.add("nav-sticky");
        } else {
          topnav.classList.remove("nav-sticky");
        }
      }
    };
    window.addEventListener("scroll", scrollNavigation);
    return () => {
      window.removeEventListener("scroll", scrollNavigation);
    };
  }, []);

  const toggleSeeMore = (e) => {
    e.preventDefault();
    setIsSeeMore(!isSeeMore);
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Services | Subul Contracting</title>
      </MetaTags>

      {data && (
        <>
          <section className="bg-half-170 bg-light d-table w-100">
            <Container>
              <Row className="mt-5 justify-content-center">
                <Col lg={12} className="text-center">
                  <div className="pages-heading">
                    <h1 className="title mb-0">{data?.page_heading}</h1>
                  </div>
                </Col>
              </Row>
              <div className="position-breadcrumb">
                <nav aria-label="breadcrumb" className="d-inline-block">
                  <ul className="breadcrumb rounded shadow mb-0 px-4 py-2">
                    {data?.breadcrumb?.map((item, index) => (
                      <li className={item?.className} key={index}>
                        {item?.link ? <Link to={item.link}>{item.name}</Link> : item?.name}
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </Container>
          </section>

          <div className="position-relative">
            <div className="shape overflow-hidden text-white">
              <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
              </svg>
            </div>
          </div>

          <div className="py-5">
            <ServicesSection seeMore={false} />
          </div>
          
          {/* features list */}
          <section className="section">
            <Container>
                {/* Section Title */}
                <Row className="justify-content-center">
                    <Col xs={12} className="text-center">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-3">{data?.features_heading || 'Our Features'}</h4>
                            <p className="text-muted para-desc mx-auto mb-0">
                                {data?.features_subheading || 'Explore the great features that make our services stand out from the rest.'}
                            </p>
                        </div>
                    </Col>
                </Row>
                
                {/* Features Grid */}
                <Row>
                    {data?.features_list?.slice(0, isSeeMore ? data.features_list.length : 6).map((item, key) => (
                        <Col key={key} lg={4} md={6} xs={12} className="mt-4 pt-2">
                            <Card className="features feature-primary text-center border-0 rounded-3 shadow-sm p-4 h-100">
                                <div className="image position-relative d-inline-block">
                                    <i className={item.icon} style={{ fontSize: '36px' }}></i>
                                </div>
                                <CardBody className="p-0 mt-4">
                                    <h5 className="title">{item.title}</h5>
                                    <p className="text-muted mb-0">{item.description}</p>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                    <Col xs={12} className="text-center mt-5 pt-2">
                        <Link to="#" className="btn btn-primary rounded-pill" onClick={toggleSeeMore}>
                            {isSeeMore ? data.hideMore : data.seeMore}{' '}
                            <i className={`mdi mdi-arrow-${isSeeMore ? 'up' : 'down'}`}></i>
                        </Link>
                    </Col>
                </Row>
            </Container>
          </section>

          <section className="section bg-light">
            <Container>
              <Row className="justify-content-center">
                <Col xs="12" className="text-center">
                  <div className="section-title">
                    <h4 className="title mb-4">{data?.endSection?.title}</h4>
                    <p className="text-muted para-desc mx-auto">
                      {data?.endSection?.description.map((item, index) => (
                        item.type === "highlighted" ? (
                          <span key={index} className="text-primary fw-bold">{" "}{item.content}{" "}</span>
                        ) : (
                          <span key={index}>{item.content}</span>
                        )
                      ))}
                    </p>
                    <div className="mt-4 pt-2">
                      <Link to="/contact-us" className="btn btn-primary rounded-pill mt-2 me-2">
                        {data?.endSection?.buttonText}
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </>
      )}
    </React.Fragment>
  );
}

export default Services;